import { isLgAg26Variation } from './isLgAg26Variation';
import { isStAg26Variation } from './isStAg26Variation';

/**
 * Shared chrome for UAE Marketing DCB v5 landings (`lg_ag26` + `st_ag26`):
 * header bar, language pill, footer, white theme, exit link.
 */
export const isAg26MarketingVariation = (): boolean =>
  isLgAg26Variation() || isStAg26Variation();
